import { useMemo } from "react";
import {
  DateField,
  DatagridConfigurable,
  FunctionField,
  NumberField,
  TextField,
  useTranslate,
  useTheme,
} from "react-admin";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import printHistoryFilterList from "../../components/invoicePrintHistories/filter/invoicePrintHistoryFilterList";
import ManualReportList from "../../components/reports/ManualReportList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const PrintHistoryList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");
  const translate = useTranslate();

  return useMemo(
    () => (
      <ManualReportList
        title="resources.print_histories.name"
        empty={false}
        actions={<DownloadAction />}
        filters={printHistoryFilterList(permissions)}
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
        queryOptions={{ meta: { sort: ["created_at DESC"] } }}
      >
        <DatagridConfigurable
          bulkActionButtons={false}
          sx={{
            "& .RaDatagrid-rowCell": { verticalAlign: "top" },
            "& .RaDatagrid-headerCell": { whiteSpace: "nowrap" },
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField
              source="company_alias"
              label="mine.label.company"
              sortable={false}
            />
          ) : null}
          <FunctionField
            label="mine.label.document_type"
            render={(record) => {
              return (
                translate(`mine.document_type.${record.document_type}`) ||
                record.document_type
              );
            }}
          />
          <TextField source="document_code" label="mine.label.receipt_no" />
          <DateField
            source="document_date"
            label="mine.label.date"
            options={{ year: "numeric", month: "short", day: "2-digit" }}
          />
          <NumberField source="print_count" label="Jumlah Cetak" />
          <DateField
            source="created_at"
            label="mine.label.created_at"
            showTime
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            }}
          />
          <FunctionField
            label="mine.label.user"
            render={(record) =>
              [record.first_name, record.last_name]
                .filter(Boolean)
                .join(" ") || record.username || "-"
            }
          />
          <TextField source="reason" label="mine.label.reason" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues, translate]
  );
};

export default PrintHistoryList;
